"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var student_reportcards_html_1 = __importDefault(require("./student-reportcards.html"));
var student_reportcards_controller_1 = __importDefault(require("./student-reportcards.controller"));
var time_1 = require("../../../common/helpers/time");
function getStudent(UsersModel, $stateParams) {
    return UsersModel.getStudentByID($stateParams.student_id).then(function (response) {
        response.usermeta.certificate_issue_date = (0, time_1.dateOrEmptyString)(response.usermeta.certificate_issue_date);
        response.usermeta.drive_deadline = (0, time_1.dateOrEmptyString)(response.usermeta.drive_deadline);
        response.usermeta.start_date = (0, time_1.dateOrEmptyString)(response.usermeta.start_date);
        if (response.usermeta.permit) {
            response.usermeta.permit.issuedate = (0, time_1.dateOrEmptyString)(response.usermeta.permit.permit_issue_date);
            response.usermeta.permit.expirationdate = (0, time_1.dateOrEmptyString)(response.usermeta.permit.permit_expiration_date);
        }
        return response;
    });
}
getStudent.$inject = ["UsersModel", "$stateParams"];
function getReportCards(UsersModel, $stateParams) {
    return UsersModel.getStudentReportcards({
        id: $stateParams.student_id,
        page_by: 15,
    }).then(function (response) {
        return response;
    });
}
getReportCards.$inject = ["UsersModel", "$stateParams"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.instructor.dashboard.studentreportcards", {
        url: "/student/:student_id/reportcards",
        template: student_reportcards_html_1.default,
        controller: student_reportcards_controller_1.default,
        controllerAs: "vm",
        resolve: {
            student: getStudent,
            reportcards: getReportCards,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.instructor,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("instructor.dashboard.studentreportcards", [])
    .config(config)
    .controller("InstructorStudentReportCardsController", student_reportcards_controller_1.default);
